<div class="lightbox-overlay" *ngIf="open" (click)="close()" role="dialog" aria-modal="true">

    <button class="lightbox-close" (click)="close()" aria-label="Fermer">
        <i class="icofont-close"></i>
    </button>

    <button class="lightbox-prev" *ngIf="total > 1" (click)="prev($event)" aria-label="Précédent">
        <i class="icofont-double-left"></i>
    </button>

    <div class="lightbox-content" (click)="stop($event)">
        <ng-container *ngIf="current">
            <video *ngIf="isVideo(current)" class="lightbox-media" controls autoplay [src]="current.url"></video>
            <img   *ngIf="!isVideo(current)" class="lightbox-media" [src]="current.url" [alt]="current.caption || ''">
        </ng-container>

        <p class="lightbox-caption" *ngIf="current?.caption">{{ current?.caption }}</p>

        <p class="lightbox-counter" *ngIf="total > 1">{{ index + 1 }} / {{ total }}</p>
    </div>

    <button class="lightbox-next" *ngIf="total > 1" (click)="next($event)" aria-label="Suivant">
        <i class="icofont-double-right"></i>
    </button>

</div>
